import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { NewCommentPayload } from '../../shared/components/comments/comments.component';
import type { Comment } from '../../shared/components/comments/models/comments-service.interface';
import type { TableQuery } from '../../shared/components/generic-table/models/table-query.model';
import type {
  CaseInvestigationHeader,
  CaseInvestigationIncidentRow,
} from '../../features/variance-tracker/case-investigation/models/case-investigation.models';
import type { CaseInvestigationStatusLogDto } from '../../features/variance-tracker/case-investigation/models/case-investigation-status-log.model';

export interface TableDataResponse<T> {
  readonly data: readonly T[];
  readonly totalRecords: number;
}

export interface CaseInvestigationClient {
  getHeader(caseId: string): Observable<CaseInvestigationHeader>;
  getIncidentRows(
    caseId: string,
    query: TableQuery,
  ): Observable<TableDataResponse<CaseInvestigationIncidentRow>>;
  /** Updates case investigation (e.g. status). Sends status as API enum name (e.g. "PendingResponse"). */
  updateCaseStatus(caseId: string, status: string, organizationId: string): Observable<void>;
  /** Loads status change logs for the case (timeline alignment). */
  getStatusLogs(
    caseId: number,
    organizationId: number,
  ): Observable<readonly CaseInvestigationStatusLogDto[]>;
  /** Loads comments for the case from the comment thread API. */
  getComments(caseId: string): Observable<readonly Comment[]>;
  /** Posts a new comment to the thread; call getComments after success to refresh the list. */
  addComment(caseId: string, payload: NewCommentPayload, authorUserId: string): Observable<void>;
}

export const CASE_INVESTIGATION_CLIENT = new InjectionToken<CaseInvestigationClient>(
  'CASE_INVESTIGATION_CLIENT',
);
